import { css, html, LitElement } from "lit";

import "../components/navbar";

import { setTitle, trackPage } from "../common/client";
import { websiteStyles } from "../styles/website";

export class NotFoundPage extends LitElement {
  static styles = [
    websiteStyles,
    css`
      :host {
        display: block;
        width: 100vw;
        height: 100vh;
        background: #FFF;
        color: black;
        padding-top: 100px;
        text-align: center;
      }

      h1 {
        color: red;
      }
    `,
  ];

  connectedCallback() {
    super.connectedCallback();

    trackPage();
    setTitle("Page Not Found");
  }

  render() {
    return html`<navbar-component></navbar-component>
      <h1>404 - Not Found</h1>
      <p>The page you are looking for does not exist.</p>
      <p>
        <a href="./">Go to Home Page</a>
      </p>`;
  }
}

customElements.define("not-found-page", NotFoundPage);
